<div class="block-header">
  <h3 class="block-title">Datos del vehículo</h3>
</div>

<div class="form-horizontal">
    <div class="form-group">
        <label class="col-md-2 control-label">Marca:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Marca</mat-label>
            <input matInput type="text" placeholder="marca" [(ngModel)]="vehiculo.marca" [disabled]="disabled"/>
          </mat-form-field>                
        </div>
        <label class="col-md-2 control-label">Año:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Año</mat-label>
            <input matInput type="text" placeholder="año" [(ngModel)]="vehiculo.anio" [disabled]="disabled" />
          </mat-form-field>
        </div>  
        <label class="col-md-2 control-label">Combustible:</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline">
          <mat-label>Combustible</mat-label>
          <input matInput type="text" placeholder="combustible" [(ngModel)]="vehiculo.combustible" [disabled]="disabled"/>
        </mat-form-field>            
      </div>  
    </div>   
    <div class="form-group">
      <label class="col-md-2 control-label">Placa:</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline">
          <mat-label>Placa</mat-label>
          <input matInput type="text" placeholder="placa" [(ngModel)]="vehiculo.placa" [disabled]="disabled"/>
        </mat-form-field>            
      </div>             
    <label class="col-md-2 control-label">Color:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>Color</mat-label>
        <input matInput type="text" placeholder="color" [(ngModel)]="vehiculo.color" [disabled]="disabled"/>
      </mat-form-field>          
    </div>
    <label class="col-md-2 control-label">T. Propiedad:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>Tarjeta de Propiedad</mat-label>
        <input matInput type="text" placeholder="t. propiedad" [(ngModel)]="vehiculo.tarjetaPropiedad" [disabled]="disabled"/>
      </mat-form-field>          
    </div>        
  </div>
  <div class="form-group">
    <label class="col-md-2 control-label">Soat:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>Soat</mat-label>
        <input matInput type="text" placeholder="soat" [(ngModel)]="vehiculo.soat" [disabled]="disabled"/>
      </mat-form-field>          
    </div>
    <label class="col-md-2 control-label">Modelo:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>Modelo</mat-label>
        <input matInput type="text" placeholder="modelo" [(ngModel)]="vehiculo.modelo" [disabled]="disabled"/>
      </mat-form-field>          
    </div>        
  </div>
</div>

<div class="block-header">
  <h3 class="block-title">Datos del chofer</h3>
</div>
<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-2 control-label">Apellido paterno:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Apellido paterno</mat-label>
        <input matInput type="text" placeholder="apellido paterno" [(ngModel)]="vehiculo.solicitudChofer.apellidoPaterno" [disabled]="disabled"/>
      </mat-form-field>          
    </div>
    <label class="col-md-2 control-label">Apellido materno:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Apellido materno</mat-label>
        <input matInput type="text" placeholder="apellido materno" [(ngModel)]="vehiculo.solicitudChofer.apellidoMaterno" [disabled]="disabled"/>
      </mat-form-field>          
    </div>       
  </div>      
  <div class="form-group">
    <label class="col-md-2 control-label">Nombres:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Nombres</mat-label>
        <input matInput type="text" placeholder="nombres" [(ngModel)]="vehiculo.solicitudChofer.nombres" [disabled]="disabled"/>
      </mat-form-field>          
    </div>
    <label class="col-md-2 control-label">Nro Licencia:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Nro Licencia</mat-label>
        <input matInput type="text" placeholder="licencia" [(ngModel)]="vehiculo.solicitudChofer.nroLicencia" [disabled]="disabled"/>
      </mat-form-field>          
    </div>        
  </div>
  <div class="form-group">
    <label class="col-md-2 control-label">Tipo de licencia:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Tipo de licencia</mat-label>
        <input matInput type="text" placeholder="tipo licencia" [(ngModel)]="vehiculo.solicitudChofer.tipoLicencia" [disabled]="disabled"/>
      </mat-form-field>          
    </div>
  </div>    
</div>